import pageFrame from '@/common/layout/pageFrame'

const RouteView = {
  name: 'RouteView',
  render: h => h('router-view')
}
export const constantRouterMap = [
    {//重定向
        path: '/',
        redirect: '/Login'
    },
    {//登录
      path: '/Login',
      name: 'Login',
      component: () => import('@/pages/Login/login')
    },
    {//框架
      path: '/Home',
      name: "index",
      component: pageFrame,
      meta:{title:'首页'},
      redirect: '/staticPage',
      children:[
          {
            path: '/staticPage',
            name: 'staticPage',
            redirect: '/staticPage/staticPage',
            component: RouteView,
            meta: { title: '订场看板', key: 'sub0', keepAlive: true, icon: 'line-chart' },
            children: [
                {
                  path: '/staticPage/staticPage',
                  name: '篮球馆看板',
                  component: () => import('@/pages/staticPage/staticPage'),
                  meta:{title:'篮球馆看板', key:"01", subKey: 'sub0'}
                },
                {
                  path: '/staticPage/badmintonPage',
                  name: '羽毛球馆看板',
                  component: () => import('@/pages/staticPage/badmintonPage'),
                  meta:{title:'羽毛球馆看板', key:"02", subKey: 'sub0'}
                },
            ]
          },
          {
            path: '/orderManage',
            name: 'orderManage',
            redirect: '/orderManage/personalOrderList',
            component: RouteView,
            meta: { title: '订单管理', key: 'sub1', keepAlive: true, icon: 'profile' },
            children: [
                // {
                //   path: '/orderManage/groupOrderList',
                //   name: '团队订单',
                //   component: () => import('@/pages/orderManage/groupOrderList.vue'),
                //   meta:{title:'团队订单', key:"10", subKey: 'sub1'},
                // },
                {
                  path: '/orderManage/personalOrderList',
                  name: '个人订单',
                  component: () => import('@/pages/orderManage/personalOrderList.vue'),
                  meta:{title:'个人订单', key:"11", subKey: 'sub1'}
                },
            ]
          },
          {
            path: '/memberManage',
            name: 'memberManage',
            redirect: '/memberManage/memberList',
            component: RouteView,
            meta: { title: '会员管理', key: 'sub2', keepAlive: true, icon: 'user' },
            children: [
                {
                  path: '/memberManage/memberList',
                  name: '会员列表',
                  component: () => import('@/pages/memberManage/memberList.vue'),
                  meta:{title:'会员列表', key:"20", subKey: 'sub2'},
                },
                {
                  path: '/memberManage/customList',
                  name: '消费记录',
                  component: () => import('@/pages/memberManage/customList.vue'),
                  meta:{title:'消费记录', key:"21", subKey: 'sub2'}
                },
                {
                  path: '/memberManage/orderList',
                  name: '订单记录',
                  component: () => import('@/pages/memberManage/orderList.vue'),
                  meta:{title:'订单记录', key:"22", subKey: 'sub2'}
                },
            ]
          },
          {
            path: '/gymManage',
            name: 'gymManage',
            redirect: '/gymManage/gymList',
            component: RouteView,
            meta: { title: '场地管理', key: 'sub3', keepAlive: true, icon: 'build' },
            children: [
                {
                  path: '/fieldManage/fieldList',
                  name: '场地配置',
                  component: () => import('@/pages/fieldManage/fieldList.vue'),
                  meta:{title:'场地配置', key:"30", subKey: 'sub3'},
                },
                {
                  path: '/gymManage/fieldPriceList',
                  name: '价格设置',
                  component: () => import('@/pages/fieldPriceManage/fieldPriceList.vue'),
                  meta:{title:'价格设置', key:"31", subKey: 'sub3'}
                },
                {
                  path: '/gymManage/fieldOrderList',
                  name: '场地预定',
                  component: () => import('@/pages/fieldOrderManage/fieldOrderList.vue'),
                  meta:{title:'场地预定', key:"32", subKey: 'sub3'}
                }
            ]
          },
          {
            path: '/customManage',
            name: 'customManage',
            redirect: '/customManage/customList',
            component: RouteView,
            meta: { title: '客流管理', key: 'sub4', keepAlive: true, icon: 'usergroup-add' },
            children: [
                {
                  path: '/customManage/customList',
                  name: '客流统计',
                  component: () => import('@/pages/customManage/customList.vue'),
                  meta:{title:'客户列表', key:"40", subKey: 'sub4'},
                },
            ]
          },
          {
            path: '/packageManage',
            name: 'packageManage',
            redirect: '/packageManage/staticPage',
            component: RouteView,
            meta: { title: '套餐管理', key: 'sub5', keepAlive: true, icon: 'branches' },
            children: [
                {
                  path: '/packageManage/packageList',
                  name: '次卡套餐',
                  component: () => import('@/pages/packageManage/packageList.vue'),
                  meta:{title:'次卡套餐', key:"50", subKey: 'sub5'}
                },
                {
                  path: '/packageManage/storagePackageList',
                  name: '储值套餐',
                  component: () => import('@/pages/packageManage/storagePackageList.vue'),
                  meta:{title:'储值套餐', key:"51", subKey: 'sub5'}
                },
                {
                  path: '/packageManage/timePackageList',
                  name: '计时套餐',
                  component: () => import('@/pages/packageManage/timePackageList.vue'),
                  meta:{title:'计时套餐', key:"52", subKey: 'sub5'}
                },
                {
                  path: '/packageManage/certificatePackageList',
                  name: '时段套餐',
                  component: () => import('@/pages/packageManage/certificatePackageList.vue'),
                  meta:{title:'时段套餐', key:"53", subKey: 'sub5'}
                }
            ]
          },
          {
            path: '/ledgerManage',
            name: 'ledgerManage',
            redirect: '/ledgerManage/ledgerList',
            component: RouteView,
            meta: { title: '台账管理', key: 'sub6', keepAlive: true, icon: 'account-book' },
            children: [
                {
                  path: '/ledgerManage/ledgerList',
                  name: '台账结账',
                  component: () => import('@/pages/memberManage/memberList.vue'),
                  meta:{title:'台账结账', key:"60", subKey: 'sub6'},
                },
                {
                  path: '/ledgerManage/refundList',
                  name: '退款记录',
                  component: () => import('@/pages/ledgerManage/refundList.vue'),
                  meta:{title:'退款记录', key:"61", subKey: 'sub6'},
                },
            ]
          },
          {
            path: '/deviceManage',
            name: 'deviceManage',
            redirect: '/deviceManage/abnormalPassList',
            component: RouteView,
            meta: { title: '设备管理', key: 'sub7', keepAlive: true, icon: 'lock' },
            children: [
                // {
                //   path: '/deviceManage/deviceLog',
                //   name: '设备日志',
                //   component: () => import('@/pages/memberManage/memberList.vue'),
                //   meta:{title:'设备日志', key:"70", subKey: 'sub7'},
                // },
                // {
                //   path: '/deviceManage/deviceLog',
                //   name: '设备配置',
                //   component: () => import('@/pages/memberManage/memberList.vue'),
                //   meta:{title:'设备配置', key:"71", subKey: 'sub7'},
                // },
                {
                  path: '/deviceManage/abnormalPassList',
                  name: '异常处理',
                  component: () => import('@/pages/deviceManage/abnormalPassList.vue'),
                  meta:{title:'异常处理', key:"72", subKey: 'sub7'},
                },
                {
                  path: '/deviceManage/passLogList',
                  name: '进场日志',
                  component: () => import('@/pages/deviceManage/passLogList.vue'),
                  meta:{title:'进场日志', key:"73", subKey: 'sub7'},
                },
            ]
          },
          {
            path: '/systemManage',
            name: 'systemManage',
            redirect: '/systemManage/userList',
            component: RouteView,
            meta: { title: '系统管理', key: 'sub8', keepAlive: true, icon: 'setting' },
            children: [
                {
                  path: '/systemManage/userList',
                  name: '用户管理',
                  component: () => import('@/pages/systemManage/userList.vue'),
                  meta:{title:'用户管理', key:"80", subKey: 'sub8'},
                },
                {
                  path: '/systemManage/roleList',
                  name: '角色管理',
                  component: () => import('@/pages/systemManage/roleList.vue'),
                  meta:{title:'角色管理', key:"81", subKey: 'sub8'},
                },
                /* {
                  path: '/systemManage/deviceLog',
                  name: '组织机构',
                  component: () => import('@/pages/memberManage/memberList.vue'),
                  meta:{title:'组织机构', key:"82", subKey: 'sub8'},
                }, */
                {
                  path: '/systemManage/userLogList',
                  name: '系统日志',
                  component: () => import('@/pages/systemManage/userLogList.vue'),
                  meta:{title:'系统日志', key:"83", subKey: 'sub8'},
                },
                {
                  path: '/systemManage/itemInfoManage',
                  name: '小程序配置',
                  component: () => import('@/pages/systemManage/itemInfoManage.vue'),
                  meta:{title:'小程序配置', key:"84", subKey: 'sub8'},
                },
            ]
          },
      ]
    }
]



// WEBPACK FOOTER //
// ./src/common/config/router.config.js